import { render, staticRenderFns } from "./Hue.vue?vue&type=template&id=b10229c8&"
import script from "./Hue.vue?vue&type=script&lang=js&"
export * from "./Hue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b10229c8')) {
      api.createRecord('b10229c8', component.options)
    } else {
      api.reload('b10229c8', component.options)
    }
    module.hot.accept("./Hue.vue?vue&type=template&id=b10229c8&", function () {
      api.rerender('b10229c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/utils/colorSelect/Hue.vue"
export default component.exports